var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.albums),function(album){return _c('div',{key:album.slug},[_vm._v(" "+_vm._s(album.name)+" "+_vm._s(_vm.episodes.length)+" "),_c('div',[_c('h1',[_c('a',{attrs:{"href":"route('albums.show', album.slug)","title":album.name}},[_vm._v(_vm._s(album.name))])])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }